// extracted by mini-css-extract-plugin
export var cartItem = "_n-3";
export var drawerContent = "_n-0";
export var emptyCart = "_n-2";
export var fadeIn = "_n-4";
export var imagePlaceholder = "_n-6";
export var itemImage = "_n-5";
export var itemsContainer = "_n-1";